function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { interpret as defaultInterpret, Machine as defaultMachine } from 'xstate/es';
import * as R from "../ramda";
export * from 'xstate';
export const createSender = (stateMachine, service) => {
  const handler = {
    get: (target, key) => {
      var _R$prop, _ref, _config$states, _config$invoke, _config$invoke$src, _config$config, _config$config$invoke, _config$config$invoke2, _config$config$invoke3, _ref2, _ref2$invoke, _ref2$invoke$src, _R$prop2, _ref3, _config$states2, _config$config2;

      const {
        config,
        childPath // path,

      } = target; // @ts-ignore

      const newConfig = (_R$prop = R.prop(key, // @ts-ignore
      (_ref = (_config$states = config === null || config === void 0 ? void 0 : config.states) !== null && _config$states !== void 0 ? _config$states : config === null || config === void 0 ? void 0 : (_config$invoke = config.invoke) === null || _config$invoke === void 0 ? void 0 : (_config$invoke$src = _config$invoke.src) === null || _config$invoke$src === void 0 ? void 0 : _config$invoke$src.states) !== null && _ref !== void 0 ? _ref : {} // @ts-ignore
      )) !== null && _R$prop !== void 0 ? _R$prop : config === null || config === void 0 ? void 0 : (_config$config = config.config) === null || _config$config === void 0 ? void 0 : (_config$config$invoke = _config$config.invoke) === null || _config$config$invoke === void 0 ? void 0 : (_config$config$invoke2 = _config$config$invoke.src) === null || _config$config$invoke2 === void 0 ? void 0 : (_config$config$invoke3 = _config$config$invoke2.states) === null || _config$config$invoke3 === void 0 ? void 0 : _config$config$invoke3[key];
      const isChild = !!((_ref2 = (_R$prop2 = R.prop(key, // @ts-ignore
      (_ref3 = (_config$states2 = config === null || config === void 0 ? void 0 : config.states) !== null && _config$states2 !== void 0 ? _config$states2 : config === null || config === void 0 ? void 0 : (_config$config2 = config.config) === null || _config$config2 === void 0 ? void 0 : _config$config2.states) !== null && _ref3 !== void 0 ? _ref3 : {} // @ts-ignore
      )) !== null && _R$prop2 !== void 0 ? _R$prop2 : config) === null || _ref2 === void 0 ? void 0 : (_ref2$invoke = _ref2.invoke) === null || _ref2$invoke === void 0 ? void 0 : (_ref2$invoke$src = _ref2$invoke.src) === null || _ref2$invoke$src === void 0 ? void 0 : _ref2$invoke$src.states);
      const newTarget = {
        config: newConfig,
        path: [...target.path, key],
        childPath: [...childPath, ...(isChild ? [`(machine).${key}:invocation[0]`] : [])]
      };
      return newConfig // @ts-ignore
      ? new Proxy(newTarget, handler) : (data, options) => {
        const hasChild = R.isNotEmpty(childPath);
        const currentMachine = hasChild ? getEndMachine(childPath, service.state) : service;

        if (!currentMachine) {
          console.warn(`This machine hasn't initialized yet: ${childPath.join('/')}`);
          return;
        }

        const {
          send
        } = currentMachine;
        return send(_objectSpread({
          type: key,
          data
        }, options));
      };
    }
  };
  return new Proxy({
    config: stateMachine.config,
    path: [],
    childPath: []
  }, handler);
};

const getEndMachine = (childPath, service) => {
  const [currentPath, ...rest] = childPath;
  return childPath[0] ? getEndMachine(rest, service.children.get ? service.children.get(currentPath) : service.children[currentPath]) : service;
};

export const dataType = action => action;
export const Machine = (config, options, initialContext) => defaultMachine(config, options, initialContext);
export const interpret = (stateMachine, options) => {
  // @ts-ignore
  const result = defaultInterpret( // @ts-ignore
  stateMachine, options); // @ts-ignore

  result.sender = createSender(stateMachine, // @ts-ignore
  result);
  return result;
};
export const defineMachineConfig = machineConfig => machineConfig;